export const IDP_APP = 'MY_TRIPS';
export const TRIPS_REQUEST = 'trips_request';
export const SEARCH_REQUEST = 'trip_request';
export const TRIP_DETIALS_URL = '/my-trips/trip-details';
export const UPCOMING_TRIPS_URL = '/my-trips/upcoming-trips';
export const SEARCH_TRIPS_URL = '/my-trips/search?errorCodes=';
export enum EndpointKeys {
  TRAVEL_RESERVATION = 'TRAVEL_RESERVATION',
  FEATURE_FLAG = 'FEATURE_FLAG'
}

export enum HTTP_HEADERS {
  CONTENT_TYPE = 'application/json; charset=UTF-8',
  APP_ID = 'WEB',
  CHANNEL_ID = 'DCOM',
  GUEST = 'GUEST',
  PURCHASE_PATH = 'MYTRIPS',
  MY_TRIP = 'MyTrip',
  PREFIX = 'my-trips'
}

export enum TRIP_USING {
  CONFIRMATION = 'CONFIRMATION',
  TICKET = 'TICKET',
  CREDITCARD = 'CREDITCARD',
  LOYALTYNUM = 'LOYALTYNUM'
}
